<template>
  <div>
    <b-modal
      v-model="showImageModal"
      ref="image-modal"
      hide-header
      hide-footer
      centered
      size="lg"
      scrollable
    >
      <div class="d-flex flex-column select-goal-image-modal-constent">
        <div class="d-flex">
          <label class="small-icon">Select an image</label>
          <button
            type="button"
            class="modal-button-close border border-white bg-white ml-auto h4"
            @click="showImageModal = false"
          >
            ×
          </button>
        </div>
        <div class="mb-3">
          <b-button class="add-image-btn" title="Upload Image" @click="showAddImageModal = true">
            <span class="material-icons">add_photo_alternate</span>
            Upload images
          </b-button>
        </div>
        <div class="images-container">
          <b-form-group>
            <b-form-radio-group
              v-model="selectedImageId"
              name="radio-sub-images"
              class="grid-radio-group radio-sub-images"
            >
              <b-form-radio :value="null" :id="'0-goal-image'" class="p-0">
                <b-img
                  :style="selectedImageId === null ? 'border: green 2px solid;' : ''"
                  :src="require(`@/assets/child-profile-empty.png`)"
                  @click="showImageModal = false"
                  class="avatar-img fit-cover shadow rounded-25 mb-0"
                ></b-img>
              </b-form-radio>
              <b-form-radio
                v-for="(image, index) in criterionImages"
                :key="'image' + index + 1"
                :value="image.id"
                :id="image.id.toString() + 'goal-image'"
                class="m-0 p-0"
              >
                <b-img
                  :style="selectedImageId === image.id ? 'border: green 2px solid;' : ''"
                  :src="image.url"
                  @click="showImageModal = false"
                  class="avatar-img fit-cover shadow rounded-25 mb-0"
                ></b-img>
              </b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </div>
      </div>
    </b-modal>
    <draggable-load-files
      :show-add-image-modal="showAddImageModal"
      @close-modal="showAddImageModal = false"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import draggableLoadFiles from '@/components/general/draggableLoadFiles/draggableLoadFiles.vue';

export default {
  components: {
    draggableLoadFiles,
  },
  data() {
    return {
      showImageModal: false,
      showAddImageModal: false,
      selectedImageId: null,
    };
  },
  async mounted() {
    try {
      await this.fetchCriterionImages(this.getUserId);
    } catch (error) {
      console.error(error);
    }
  },
  computed: {
    ...mapGetters('challenge', ['getCriterionImages']),
    ...mapGetters('user', ['getUserId']),
    criterionImages() {
      return this.getCriterionImages
        .map((image) => {
          return { id: parseInt(image.id), text: image.name, url: image.image };
        })
        .sort((a, b) => +a.id - +b.id);
    },
  },
  methods: {
    ...mapActions('challenge', ['fetchCriterionImages']),
    openModal() {
      this.showImageModal = true;
    },
    closeModal() {
      this.showImageModal = false;
    },
  },
  watch: {
    selectedImageId() {
      this.$emit('onChangeSelectedImage', {
        selected: !!this.selectedImageId,
        imageId: this.selectedImageId,
      });
    },
  },
};
</script>
<style lang="scss">
.images-container {
  .custom-radio {
    margin: 0;
  }

  .grid-radio-group {
    &.radio-sub.images.bv-no-focus-ring {
      display: grid;
    }
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    grid-template-rows: auto;
    gap: 1rem;

    .custom-radio .custom-control-label::before {
      z-index: -1;
      left: 0;
    }
  }
}
</style>
